import { render, staticRenderFns } from "./CarbonOffsetProcess.vue?vue&type=template&id=354c1730&scoped=true"
import script from "./CarbonOffsetProcess.vue?vue&type=script&lang=js"
export * from "./CarbonOffsetProcess.vue?vue&type=script&lang=js"
import style0 from "./CarbonOffsetProcess.vue?vue&type=style&index=0&id=354c1730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9a5d4250dd08d9b6c6ab534d53b24d01/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c1730",
  null
  
)

export default component.exports